module.exports = __webpack_public_path__ + "img/SE5164010224.24fd529c.png";